/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Component of the security
 */
export enum SecurityValueOverrideComponent {
    COMPONENT_TRACKING = 'COMPONENT_TRACKING',
    COMPONENT_INTEREST = 'COMPONENT_INTEREST',
    COMPONENT_PRINCIPAL = 'COMPONENT_PRINCIPAL',
    COMPONENT_LIQUIDATION_PREFERENCE = 'COMPONENT_LIQUIDATION_PREFERENCE',
    COMPONENT_CATCH_UP = 'COMPONENT_CATCH_UP',
    WHOLE_SECURITY = 'WHOLE_SECURITY',
    COMPONENT_RESIDUE = 'COMPONENT_RESIDUE',
}
